import { useVariableGroups } from "api/variableGroups";
import { SingleCollectionData } from "components/Layout/Collection/types";
import { MoreElements } from "components/MoreElements/MoreElements";
import { useStyles } from "../ConditionReadOnly";

export const GroupsBox = ({
  groupIds,
  maxVisibleConditionDataCount,
}: {
  groupIds: string[];
  maxVisibleConditionDataCount: number;
}) => {
  const classes = useStyles();
  const { useVariableGroupDetails } = useVariableGroups();
  const { data: selectedGroups } = useVariableGroupDetails(groupIds);
  return (
    <>
      {selectedGroups
        ?.slice(0, maxVisibleConditionDataCount)
        ?.map((group: SingleCollectionData) => (
          <div className={classes.box}>{group.name}</div>
        ))}

      <MoreElements
        maxVisibleElementsCount={maxVisibleConditionDataCount}
        totalItemsNumber={selectedGroups?.length}
        tooltipData={{
          type: "labels",
          data: selectedGroups
            ?.slice(maxVisibleConditionDataCount)
            ?.map((group: SingleCollectionData) => group.name),
        }}
      />
    </>
  );
};
